<template>
    <v-container>
        <v-row class="my-8">
            <v-col cols="12">
                <div class="display-3 text-center"
                     :style="{color: $vuetify.theme.themes.dark.primary}">Choose
                    a topic
                </div>
            </v-col>
        </v-row>
        <div class="d-flex flex-wrap justify-center">
            <a :href="story.route" v-for="(story,i) in sortedStoriesByGoals"
               :key="i" class="map-card ma-6"
               @click="storySelected($event, story.route, i)">
                <v-card max-width="450px">
                    <v-img :src="story.image"
                           class="map-image" max-height="250px"
                           aspect-ratio="1">
                        <div class="map-text body-1 pa-2"
                             v-html="story.description">
                        </div>
                    </v-img>
                    <v-card-title
                            class="headline font-weight-medium justify-center pa-0">
                        <v-spacer></v-spacer>
                        <div class="ma-2" v-html="story.title" />
                        <v-spacer></v-spacer>
                        <div class="ma-2 d-flex">
                            <v-img class="mx-1" v-for="(goalImage,i) in story.goalImages"
                                   :key="i" max-height="80px" max-width="80px"
                                   :src="require(`@/assets/sdg_logos/${goalImage}`)"/>
                        </div>
                    </v-card-title>
                </v-card>
            </a>
        </div>
    </v-container>
</template>

<script>
    import stories from "@/models/stories";

    export default {
        name: "Content",
        data: () => ({
          stories
        }),
        mounted() {
          //when back button is pressed and route is changed to this component
          //reset the header to the default state
          this.stories.current = null;
        },
        methods: {
            storySelected: function (event, storyRoute, i) {
                event.preventDefault();
                event.stopPropagation();

                this.stories.current = i;
                this.$router.push("/" + storyRoute);
            }
        },
        computed: {
            sortedStoriesByGoals() {
                return [...this.stories.items].sort((a, b) => a.goalString.localeCompare(b.goalString));
            }
        }
    };
</script>

<style>
    html {
        overflow-y: auto !important;
    }

    .points {
        padding-top: 5px !important;
        padding-bottom: 5px !important;
    }

    .map-card {
        text-decoration: none;
    }

    .map-card:hover .map-image > .v-image__image {
        opacity: 0.1;
    }

    .map-card:hover .map-text {
        opacity: 1;
    }

    .map-text {
        opacity: 0;
    }

    .map-image > .v-image__image, .map-text {
        transition: opacity 0.5s;
    }
</style>